<template>
  <div id="app">
    <div>
      <page-header ref="header"></page-header>
      <div>
        <router-view ref="main"/>
      </div>

      <page-footer></page-footer>
    </div>
  </div>
</template>
<script>
import PageHeader from '@/components/PageHeader'
import PageFooter from '@/components/PageFooter'
import MobileDetect from "mobile-detect";

export default {
  name: "App",
  mixins: [],
  components: {PageHeader, PageFooter},
  props: {},
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  beforeCreate() {
    let md = new MobileDetect(window.navigator.userAgent);
    if(md.mobile() !== null){
      location.href="http://m.fathers.or.kr/";
    }
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {},
  watch: {},
}
</script>

<style lang="scss">
@import "assets/scss/index.scss";
</style>
